import {
  createStyleElement,
  removeStyleElement,
} from '../../../shares/ui/createStyleElement';
import { getSDKConfig } from '../../../shares/lib/getSDKConfig';
import { errorContent } from '../../../shares/ui/errorUI';
import simulateSpecialsStyles from './simulateSpecialsStyles.css?inline';

export const simulateSpecialsElements: Record<string, any> = {
  containers: [],
  overlays: [],
  mains: [],
  iframes: [],
};

export function getSimulateSpecialsElements() {
  const { simulateSpecials } = getSDKConfig();

  const containerIds = simulateSpecials?.iframeContainerId;
  const ids = Array.isArray(containerIds) ? containerIds : [containerIds];

  createStyleElement('sms-style', simulateSpecialsStyles);

  const containers: HTMLElement[] = [];
  const overlays: HTMLElement[] = [];
  const mains: HTMLElement[] = [];

  for (const containerId of ids) {
    const container = document.querySelector<HTMLElement>(`${containerId}`);

    if (!container) {
      console.warn(`Simulate Specials container not found: ${containerId}`);
      continue;
    }

    container.classList.add('sms-root');

    const overlay = document.createElement('div');
    overlay.className = 'sms-overlay';
    overlay.hidden = true;

    const main = document.createElement('div');
    main.className = 'sms-main';
    main.hidden = true;

    container.replaceChildren(overlay, main);

    containers.push(container);
    overlays.push(overlay);
    mains.push(main);
  }

  if (containers.length === 0) {
    throw new Error(`No valid Simulate Specials containers found`);
  }

  simulateSpecialsElements.containers = containers;
  simulateSpecialsElements.overlays = overlays;
  simulateSpecialsElements.mains = mains;

  return { containers, overlays, mains, showError, showLoader, hideLoader };
}

export function clearSimulateSpecialsElements() {
  removeStyleElement('sms-style');
  hideLoader();

  if (simulateSpecialsElements.iframes) {
    simulateSpecialsElements.iframes.forEach((iframe: HTMLElement) =>
      iframe?.remove(),
    );
    simulateSpecialsElements.iframes = [];
  }

  if (simulateSpecialsElements.mains) {
    simulateSpecialsElements.mains.forEach((main: HTMLElement) =>
      main?.remove(),
    );
    simulateSpecialsElements.mains = [];
  }

  if (simulateSpecialsElements.containers) {
    simulateSpecialsElements.containers.forEach((container: HTMLElement) => {
      if (container) {
        container.hidden = true;
        container.classList.remove('sms-root');
      }
    });
    simulateSpecialsElements.containers = [];
  }

  if (simulateSpecialsElements.overlays) {
    simulateSpecialsElements.overlays = [];
  }
}

export function showLoader() {
  if (simulateSpecialsElements.overlays) {
    const loaderHtml = `<span class="sms-loader" />`;
    simulateSpecialsElements.overlays.forEach((overlay: HTMLElement) => {
      if (overlay) {
        overlay.hidden = false;
        overlay.innerHTML = loaderHtml;
      }
    });
  }
}

export function hideLoader() {
  if (simulateSpecialsElements.overlays) {
    simulateSpecialsElements.overlays.forEach((overlay: HTMLElement) => {
      if (overlay) {
        overlay.remove();
      }
    });
    simulateSpecialsElements.overlays = [];
  }
}

export function showError() {
  if (simulateSpecialsElements.iframes) {
    simulateSpecialsElements.iframes.forEach((iframe: HTMLElement) => {
      if (iframe) iframe.hidden = true;
    });
  }

  if (simulateSpecialsElements.mains) {
    simulateSpecialsElements.mains.forEach((main: HTMLElement) => {
      if (main) main.hidden = true;
    });
  }

  if (simulateSpecialsElements.overlays) {
    const { title, subTitle, description, buttonTitle } = errorContent();

    const errorHtml = `<div class="sms-error-box">
      <h2 class="sms-error-title">${title}</h2>
      <h4 class="sms-error-sub">${subTitle}</h4>
      <p class="sms-error-dsc">${description}</p>
      <button class="sms-error-btn" onclick="location.reload()">
        ${buttonTitle}
      </button>
    </div>`;

    simulateSpecialsElements.overlays.forEach((overlay: HTMLElement) => {
      if (overlay) {
        overlay.hidden = false;
        overlay.innerHTML = errorHtml;
      }
    });
  }
}
